import { Col, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ReactSelect from 'react-select'
import DefaultDatePicker from '../../../../common/datepicker/DefaultDatePicker.jsx'
import { reactSelectSearchSettings } from '../../../../common/reactselect.js'

export function InternationalSituations({
	person,
	handleNationalDetails,
	selectChange,
	countryOptions,
	fieldParams,
	formErrors,
	isPersonal,
}) {
	const { t } = useTranslation()
	const prefix = 'internationalSituations'

	return (
		<>
			<Row className="mb-3">
				<Form.Group as={Col} controlId="idType">
					<Form.Label>{t('IdType', 'Tunnisteen tyyppi')}</Form.Label>
					<Form.Select
						key={`idType-${person.personId ?? 'new'}`}
						onChange={handleNationalDetails}
						defaultValue={person.nationalDetails?.idType}
						disabled={isPersonal}
					>
						<option value="" />
						<option value="3">{t('VAT', 'Alv-tunniste (VAT)')}</option>
						<option value="4">{t('GIIN', 'GIIN-tunniste')}</option>
						<option value="5">{t('TIN', 'Verotunniste (TIN)')}</option>
						<option value="6">{t('TradeRegister', 'Kaupparekisteritunnus')}</option>
						<option value="7">{t('ForeignBusinessID', 'Ulkomainen yritystunnus ')}</option>
						<option value="9">{t('ForeignSocSec', 'Ulkomainen henkilötunnus')}</option>
						<option value="99">{t('OtherID', 'Muu tunnus')}</option>
						<option value="100">{t('NoID', 'Ei tunnistetta')}</option>
					</Form.Select>
					<Form.Control.Feedback type="invalid">{formErrors.idType}</Form.Control.Feedback>
				</Form.Group>

				<Form.Group as={Col} controlId="id">
					<Form.Label>{t('Id', 'Tunniste')}</Form.Label>
					<Form.Control
						onChange={handleNationalDetails}
						defaultValue={person.nationalDetails?.id}
						isInvalid={!!formErrors.id}
						maxLength={fieldParams.id?.maxLength}
						disabled={isPersonal}
					/>
					<Form.Control.Feedback type="invalid">{formErrors.id}</Form.Control.Feedback>
				</Form.Group>
			</Row>

			<Form.Group className="mb-3 mt-4" controlId="dateOfBirth">
				<DefaultDatePicker
					id={`${prefix}-dateOfBirth`}
					name="dateOfBirth"
					label={t('DateOfBirth', 'Syntymäaika')}
					value={person.nationalDetails?.dateOfBirth?.slice(0, 10) || ''}
					onChange={(iso) => handleNationalDetails({ target: { id: 'dateOfBirth', value: iso ?? '' } })}
					disabled={isPersonal}
				/>
				<Form.Control.Feedback type="invalid">{formErrors.dateOfBirth}</Form.Control.Feedback>
			</Form.Group>

			<Form.Group className="mb-3" controlId="co">
				<Form.Label>{t('COSpecifier', 'C/o-tarkenne')}</Form.Label>
				<Form.Control
					onChange={handleNationalDetails}
					defaultValue={person.nationalDetails?.co}
					isInvalid={!!formErrors.co}
					maxLength={fieldParams.co?.maxLength}
					disabled={isPersonal}
				/>
				<Form.Control.Feedback type="invalid">{formErrors.co}</Form.Control.Feedback>
			</Form.Group>

			<Row className="mb-3">
				<Form.Group as={Col} controlId="street">
					<Form.Label>{t('StreetAddress', 'Katuosoite')}</Form.Label>
					<Form.Control
						onChange={handleNationalDetails}
						defaultValue={person.nationalDetails?.street}
						isInvalid={!!formErrors.street}
						maxLength={fieldParams.street?.maxLength}
						disabled={isPersonal}
					/>
					<Form.Control.Feedback type="invalid">{formErrors.street}</Form.Control.Feedback>
				</Form.Group>

				<Form.Group as={Col} controlId="poBox">
					<Form.Label>{t('PoBox', 'Postilokero')}</Form.Label>
					<Form.Control
						onChange={handleNationalDetails}
						defaultValue={person.nationalDetails?.poBox}
						isInvalid={!!formErrors.poBox}
						maxLength={fieldParams.poBox?.maxLength}
						disabled={isPersonal}
					/>
					<Form.Control.Feedback type="invalid">{formErrors.poBox}</Form.Control.Feedback>
				</Form.Group>
			</Row>

			<Row className="mb-3">
				<Form.Group as={Col} controlId="postalCode">
					<Form.Label>{t('PostNumber', 'Postinumero')}</Form.Label>
					<Form.Control
						onChange={handleNationalDetails}
						defaultValue={person.nationalDetails?.postalCode}
						isInvalid={!!formErrors.postalCode}
						maxLength={fieldParams.postalCode?.maxLength}
						disabled={isPersonal}
					/>
					<Form.Control.Feedback type="invalid">{formErrors.postalCode}</Form.Control.Feedback>
				</Form.Group>

				<Form.Group as={Col} controlId="postOffice">
					<Form.Label>{t('PostOffice', 'Postitoimipaikka')}</Form.Label>
					<Form.Control
						onChange={handleNationalDetails}
						defaultValue={person.nationalDetails?.postOffice}
						isInvalid={!!formErrors.postOffice}
						maxLength={fieldParams.postOffice?.maxLength}
						disabled={isPersonal}
					/>
					<Form.Control.Feedback type="invalid">{formErrors.postOffice}</Form.Control.Feedback>
				</Form.Group>
			</Row>

			<Row className="mb-3">
				<Form.Group as={Col} controlId="countryCode">
					<Form.Label>{t('Country', 'Maa')}</Form.Label>
					<ReactSelect
						name="countryCode"
						inputId="countryCode"
						onChange={selectChange}
						isClearable
						options={countryOptions}
						value={countryOptions.find((option) => option.value === person.nationalDetails?.countryCode)}
						isDisabled={isPersonal}
						{...reactSelectSearchSettings(t)}
					/>
					<Form.Control.Feedback type="invalid">{formErrors.countryCode}</Form.Control.Feedback>
				</Form.Group>

				<Form.Group as={Col} controlId="countryName">
					{person.nationalDetails?.countryCode === '99' && (
						<>
							<Form.Label>{t('CountryOther', 'Muu maa')}</Form.Label>
							<Form.Control
								onChange={handleNationalDetails}
								defaultValue={person.nationalDetails?.countryName}
								isInvalid={!!formErrors.countryName}
								maxLength={fieldParams.countryName?.maxLength}
								disabled={isPersonal}
							/>
							<Form.Control.Feedback type="invalid">{formErrors.countryName}</Form.Control.Feedback>
						</>
					)}
				</Form.Group>
			</Row>
		</>
	)
}
